var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4842 -2943)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4842 2943)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4957.3 -3043.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.033,128.013l-.4-.213-.4.213a22.254,22.254,0,0,1-10.411,2.67l-.825.009v6.869a17.245,17.245,0,0,0,11.347,16.158l.287.1.287-.1a17.245,17.245,0,0,0,11.347-16.158v-6.869l-.825-.009A22.2,22.2,0,0,1,152.033,128.013Zm9.576,9.548a15.585,15.585,0,0,1-9.966,14.489,15.576,15.576,0,0,1-9.966-14.489v-5.238h0a23.8,23.8,0,0,0,9.966-2.642,23.938,23.938,0,0,0,9.966,2.642Z",
    transform: "translate(-16.059 -18.963)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.523,110.061a20.451,20.451,0,0,1-10.939-3.161,20.416,20.416,0,0,1-10.939,3.161H122.3V118.6a18.952,18.952,0,0,0,13.284,18,18.944,18.944,0,0,0,13.284-18v-8.538Zm.686,8.538a17.245,17.245,0,0,1-11.347,16.158l-.287.1-.287-.1A17.235,17.235,0,0,1,123.941,118.6V111.73l.825-.009a22.172,22.172,0,0,0,10.411-2.67l.4-.213.4.213a22.246,22.246,0,0,0,10.4,2.67l.825.009V118.6Z",
    transform: "translate(0 0)",
    fill: "#72ca32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.232,266.666a1.066,1.066,0,1,0-2.132,0,1.054,1.054,0,0,0,.436.853l-.167,1.511a.272.272,0,0,0,.065.2.261.261,0,0,0,.195.093h1.066a.233.233,0,0,0,.195-.093.272.272,0,0,0,.065-.2l-.167-1.511A1.025,1.025,0,0,0,256.232,266.666Z",
    transform: "translate(-119.582 -143.988)",
    fill: "#72ca32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6,210.232V211.3h4.264v-1.066a2.132,2.132,0,0,0-4.264,0Z",
    transform: "translate(-109.148 -91.818)",
    fill: "#72ca32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,150.742h0v5.238a15.585,15.585,0,0,0,9.966,14.489,15.585,15.585,0,0,0,9.966-14.489v-5.238a23.8,23.8,0,0,1-9.966-2.642A23.8,23.8,0,0,1,158.1,150.742Zm13.692,5.052v1.066h.8a.269.269,0,0,1,.269.269v6.665a1.072,1.072,0,0,1-1.066,1.066H164.33a1.072,1.072,0,0,1-1.066-1.066v-6.665a.269.269,0,0,1,.269-.269h.8v-1.066a3.731,3.731,0,0,1,7.463,0Z",
    transform: "translate(-32.481 -37.381)",
    fill: "#72ca32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.1802d17c01fd846f827727bd40cd0bda.svg";
export { ForwardRef as ReactComponent };